import React from 'react';
import BuyerContainer from './BuyerContainer';
const BuyerView = () => {
  return <BuyerContainer />;
};

export default BuyerView;
